var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.0825 2.61573C11.4307 1.81285 12.5693 1.81285 12.9175 2.61573L15.0238 7.47316C15.1687 7.80732 15.4838 8.03626 15.8464 8.07081L21.117 8.57304C21.9882 8.65605 22.34 9.73892 21.684 10.3181L17.7152 13.8224C17.4422 14.0635 17.3218 14.4339 17.401 14.7894L18.5521 19.9573C18.7423 20.8115 17.8212 21.4807 17.0676 21.0358L12.5084 18.3441C12.1948 18.159 11.8052 18.159 11.4916 18.3441L6.93241 21.0358C6.17882 21.4807 5.25768 20.8115 5.44794 19.9573L6.59899 14.7894C6.67817 14.4339 6.55781 14.0635 6.28479 13.8224L2.31599 10.3181C1.66 9.73892 2.01184 8.65605 2.88301 8.57304L8.1536 8.07081C8.51618 8.03626 8.8313 7.80732 8.9762 7.47316L11.0825 2.61573Z","stroke":"#262F56","strokeWidth":"1.8"}));
}

Star.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Star;

Star.default = Star;
